import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getTimezoneByMode, useTimeZone } from "../../../../../../contexts/TimeZoneContext";

dayjs.extend(utc);
dayjs.extend(timezone);

const centerCellStyle = { display: "block", textAlign: "center" };

const DayOfWeekCellRenderer = ({ row }) => {
    const { timeZone, airportsMap } = useTimeZone();
    const record = row.rawFlight || {};

    if (!record.std) {
        return <span className="schedule-draft-rdg-day-cell" style={centerCellStyle}>--</span>;
    }

    const targetTimezone = getTimezoneByMode(timeZone, record.departure_airport, airportsMap);
    const stdInTargetTimezone = dayjs.utc(record.std).tz(targetTimezone);
    if (!stdInTargetTimezone.isValid()) {
        return <span className="schedule-draft-rdg-day-cell" style={centerCellStyle}>--</span>;
    }

    const dayOfWeek = stdInTargetTimezone.day();
    return <span className="schedule-draft-rdg-day-cell" style={centerCellStyle}>{dayOfWeek === 0 ? 7 : dayOfWeek}</span>;
};

export default DayOfWeekCellRenderer;
